import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
/** Service to handle Page Title */
export class PageTitleService {

  /* #region Fields */
  private readonly _title = signal<string[] | null>(null);
  private readonly _titleChange$ = toObservable(this._title).pipe(
    filter((v): v is string[] => v !== null)
  );
  /* #endregion */

  constructor() { }

  /* #region Public Methods */
  /** Method to subscribe page Title changes */
  public titleChange(): Observable<string[]> {
    return this._titleChange$;
  }

  /** Method to set Page Title */
  public setPageTitle(pageTitles: string[]): void {
    this._title.set(pageTitles);
  }
  /* #endregion */
}
